var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9035 12.2051C16.0921 12.5433 15.2215 12.7168 14.3424 12.7157C12.5773 12.7157 10.8845 12.0145 9.63642 10.7664C8.38831 9.51826 7.68713 7.82546 7.68713 6.06036C7.68713 5.15251 7.8687 4.28766 8.19771 3.49927C6.98506 4.00515 5.94923 4.85855 5.22067 5.952C4.49211 7.04545 4.1034 8.33004 4.10352 9.64398C4.10352 11.4091 4.8047 13.1019 6.0528 14.35C7.30091 15.5981 8.99371 16.2993 10.7588 16.2993C12.0727 16.2994 13.3573 15.9107 14.4508 15.1821C15.5442 14.4536 16.3976 13.4177 16.9035 12.2051Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.02389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/darkMode.dbce3aadb94f9fb62044d39b8aceb28e.svg";
export { ForwardRef as ReactComponent };